import { Buildings, Bank, GraduationCap, Newspaper, Handshake, Briefcase, User } from "@phosphor-icons/react";

export const ORG_META = {
    government: {
        label: "Government", icon: Bank,
        bg: "#DBEAFE", border: "#2563EB", text: "#1E40AF",
    },
    industry: {
        label: "Industry", icon: Buildings,
        bg: "#F5F3FF", border: "#6B46C1", text: "#4C1D95",
    },
    academic: {
        label: "Academic", icon: GraduationCap,
        bg: "#FCE7F3", border: "#DB2777", text: "#831843",
    },
    journal: {
        label: "Peer-reviewed", icon: Newspaper,
        bg: "#FEF9C3", border: "#EAB308", text: "#713F12",
    },
    ngo: {
        label: "NGO", icon: Handshake,
        bg: "#DCFCE7", border: "#16A34A", text: "#166534",
    },
    consultant: {
        label: "Consultant", icon: Briefcase,
        bg: "#FEE2E2", border: "#DC2626", text: "#7F1D1D",
    },
    independent: {
        label: "Independent", icon: User,
        bg: "#F4F4F5", border: "#71717A", text: "#3F3F46",
    },
};

export default function OrgBadge({ type, size = "sm", withIcon = true }) {
    const meta = ORG_META[type] || ORG_META.independent;
    const Icon = meta.icon;
    const cls = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1";
    return (
        <span
            className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wider rounded-sm border ${cls}`}
            style={{ background: meta.bg, borderColor: meta.border, color: meta.text }}
        >
            {withIcon && <Icon size={size === "sm" ? 10 : 12} weight="fill" />}
            {meta.label}
        </span>
    );
}
